module.exports = __webpack_public_path__ + "img/flfw_18.7711ee66.png";